import request from '@/axios'
// 获取订阅列表
export function getSubscribeList(data) {
  return request({
    url: '/api/qca/schedules/list',
    data
  })
}

// 获取订阅详情
export function getSubscribeDetail(data) {
  return request({
    url: '/api/qca/schedules/get',
    data
  })
}

// 新建订阅
export function createSubscribe(data) {
  return request({
    url: '/api/qca/schedules/create',
    data
  })
}

// 编辑订阅
export function updateSubscribe(data) {
  return request({
    url: '/api/qca/schedules/update',
    data
  })
}

// 暂停订阅
export function pauseSubscribe(data) {
  return request({
    url: '/api/qca/schedules/pause',
    data
  })
}

// 恢复订阅
export function unpauseSubscribe(data) {
  return request({
    url: '/api/qca/schedules/unpause',
    data
  })
}

// 删除订阅
export function archiveSubscribe(data) {
  return request({
    url: '/api/qca/schedules/archive',
    data
  })
}

// 获取订阅运行结果
export function getSubscribeRuns(data) {
  return request({
    url: '/api/qca/schedules/runs',
    data
  })
}
